<body>
  <!-- <app-nav-menu></app-nav-menu> -->
  <div class="container">
    <img src="assets//logos/Resolution-Institute_Logo_Horizontal_RGB.png" width="20%" />
    <router-outlet></router-outlet>
  </div>
</body>
